import Vue from 'vue'

export function createPopup(PopupComp, props, option = {}) {
  const { closeName = 'close', ...opts } = option
  let Ctor = Vue.extend(PopupComp)
  let vm = new Ctor({
    el: document.createElement('div'),
    propsData: props || {},
    ...opts
  })

  vm.$on(closeName, () => {
    document.body.removeChild(vm.$el)
    vm.$destroy()
  })

  document.body.append(vm.$el)
  return vm
}
